import { RouteAnimationShared } from './../../utils/route-animation-shared';
import {
  Component,
  OnInit,
  OnDestroy,
  HostListener,
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  PlanPriceModel,
  ShopDataLogModel,
} from 'src/app/core/model/object/shop-model';
import { Subscription } from 'rxjs';
import { ShopPurchasePopupInputModel } from './shop-purchase-popup/shop-purchase-popup.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { ShopShared } from '../general/shared/shop-shared';
import { ShopService } from 'src/app/data/repository/shop-repository/shop.service';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { MatDialog } from '@angular/material/dialog';
import { ShopAnalyticsService } from 'src/app/data/repository/analytics-repository/shop-analytics.service';
import { GenerateDataService } from 'src/app/data/repository/generate-repository/generate-data.service';
import { GenerateModel } from 'src/app/core/model/object/generate-model';
import { GenerateService } from 'src/app/data/repository/generate-repository/generate.service';
import { ActivityLevelService } from 'src/app/data/repository/generate-repository/activity-level.service';
import { DiseaseService } from 'src/app/data/repository/generate-repository/disease.service';
import { HatedFoodService } from 'src/app/data/repository/generate-repository/hated-food.service';
import { mainUrl } from 'src/app/global-variables';
import { WeightLogService } from 'src/app/data/repository/plan-repository/weight-log.service';
import { Weightlog } from 'src/app/core/model/api-response/weight-log-response-model';
import { DateHelper } from 'src/app/utils/date-helper';
import { DiaryAnalyticsService } from 'src/app/data/repository/analytics-repository/diary-analytics.service';
import { CalendarShared } from '../general/shared/calendar-shared';
import { ShopDiscountBottomsheetComponent } from './shop-discount-bottomsheet/shop-discount-bottomsheet.component';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ShopRewardBottomsheetComponent } from './shop-reward-bottomsheet/shop-reward-bottomsheet.component';
import SwiperCore from 'swiper';
import { WebengageService } from 'src/app/data/repository/analytics-repository/webengage.service';

@Component({
  selector: 'app-shop',
  templateUrl: './shop.component.html',
  styleUrls: ['./shop.component.scss'],
})
export class ShopComponent
  implements OnInit, OnDestroy, AfterViewChecked, AfterViewInit, AfterViewInit
{
  prices: Array<PlanPriceModel>;
  currentCard: number;
  // hasTwelveAndSixDiet = false;
  lastId: number;
  oneLastId: number;
  SWIPE_ACTION = { RIGHT: 'swiperight', LEFT: 'swipeleft' };
  name = 'Angular';
  slideNo = 0;
  withAnim = true;
  resetAnim = true;
  monthNumber = 6;
  display = false;
  remainingSubscription = 0;
  showLoading = false;
  res1 = false;
  res2 = false;

  promotionCard = -1;

  activeSlide = 0;

  promotionPicture = 'assets/shop/promotion.svg';

  hasDiscount: string[] = [];
  discountCode: string;

  showSuccessPopup = false;
  popupData: ShopPurchasePopupInputModel;
  hasActiveDiet = false;

  scenario: string;

  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription4: Subscription;
  slide: boolean = false;
  cartwidth: number;
  @ViewChild('slider') slider: ElementRef<HTMLDivElement>;

  constructor(
    private shopService: ShopService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private snackBarService: SnackBarService,
    private shopShared: ShopShared,
    private shopAnalytics: ShopAnalyticsService,
    private planService: PlanService,
    private generateDataService: GenerateDataService,
    private generateService: GenerateService,
    private activityLevelService: ActivityLevelService,
    private diseaseService: DiseaseService,
    private hatedFoodService: HatedFoodService,
    private weightLogService: WeightLogService,
    private dateHelper: DateHelper,
    private diaryAnalytics: DiaryAnalyticsService,
    private calendarShared: CalendarShared,
    private router: Router,
    private routeAnimationShared: RouteAnimationShared,
    private matBottomSheet: MatBottomSheet,
    private webengage: WebengageService
  ) {
    this.scenario = this.route.snapshot.paramMap.get('scenario');
    this.getPrices();
    this.getPlanSubscription();
    this.subscription1 = this.shopShared.hasDiscountObs$.subscribe(
      (hasDiscount) => {
        if (hasDiscount) {
          this.discountCode = this.shopShared.getDiscountCode();
          this.prices = this.shopShared.getDiscountPrices();
          setTimeout(() => {
            this.prices.forEach((price) => {
              this.cdr.detectChanges();
              this.handleSlideTo();

              this.selecetDiscountPlans(this.prices);
              price.promotion = null;
            });
            // this.prices.sort(({duration: a}, {duration: b}) => a - b);
            // setTimeout(() => {
            //   this.selectCard(this.prices.length - 1);
            // }, 10);
          }, 100);
          this.shopShared.hasDiscount(false);
        }
      }
    );
    this.subscription2 = this.shopShared.dismissPopupObs$.subscribe(
      (dismiss) => {
        if (dismiss) {
          this.showSuccessPopup = false;
        }
      }
    );
    this.subscription3 = this.shopShared.confirmPopupObs$.subscribe(
      (confirm) => {
        if (confirm) {
          if (!this.hasActiveDiet) {
            this.generateDataService.getGenerate().then((res) => {
              if (res.goal) {
                this.generate(res);
              } else {
                this.planService.goToGenerate();
              }
            });
          }
          this.showSuccessPopup = false;
        }
      }
    );
    this.subscription4 = this.shopShared.hasRewardObs$.subscribe((has) => {
      if (has) {
        setTimeout(() => {
          const dialogRef = this.matBottomSheet.open(
            ShopRewardBottomsheetComponent,
            {
              panelClass: 'custom-bottomsheet-container',
              data: { type: 'reward', title: this.shopShared.reward / 30 },
            }
          );
          this.remainingSubscription += this.shopShared.reward;
          // dialogRef.afterDismissed().subscribe(() => {
          // });
        }, 150);
      }
    });
  }
  percentage(percent: number, total: number) {
    return parseInt(((percent / 100) * total).toFixed(2));
  }
  ngOnInit() {
    this.initalSlider();
    this.webengage.shopVisited();
  }

  planHasDiscount(id: string) {
    if (this.hasDiscount.includes(id)) {
      return true;
    }
    return false;
  }
  selecetDiscountPlans(plans: PlanPriceModel[]) {
    plans?.map((plan) => {
      if (parseInt(plan.discountPercent as any) > 0) {
        this.hasDiscount.push(plan._id);
      }
    });
  }
  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription4.unsubscribe();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }
  onSwiper($event: SwiperCore) {
    setTimeout(() => {
      $event.slideTo(this.activeSlide);
    }, 2000);
  }
  onSlideChange($event: SwiperCore) {
    this.activeSlide = $event.realIndex;
    this.slide = true;
    this.cdr.detectChanges();
  }

  ngAfterViewInit() {
    if (this.scenario === 'success') {
      let dataLog;
      if (localStorage.getItem('shop_data_log')) {
        const dataLogJson = localStorage.getItem('shop_data_log');
        dataLog = ShopDataLogModel.fromJSON(dataLogJson);
        // console.log('datalog', dataLog)
        // this.shopService.shopDataLog(dataLog);
        this.shopAnalytics.analyticShopPurchaseCompleted(dataLog.sku);
      }

      this.shopService
        .checkTodayPlan()
        .then((res) => {
          if (res.isSuccess()) {
            this.hasActiveDiet = true;
          } else {
            this.hasActiveDiet = false;
          }
          const dialogRef = this.matBottomSheet.open(
            ShopRewardBottomsheetComponent,
            {
              panelClass: 'custom-bottomsheet-container',
              data: { type: 'success', title: dataLog.title },
            }
          );
        })
        .then(() => {
          if (this.hasActiveDiet) {
            this.popupData = new ShopPurchasePopupInputModel(
              'خرید شما موفقیت آمیز بود.',
              '',
              'باشه',
              'assets/shop/happy.png'
            );
          } else {
            this.popupData = new ShopPurchasePopupInputModel(
              'خرید شما موفقیت آمیز بود.',
              'شما در حال حاضر برنامه غذایی ندارید!',
              'برنامه غذایی بگیرید',
              'assets/shop/happy.png'
            );
          }
        });
    }
  }
  initalSlider() {
    // this.cartwidth = window.innerWidth - 38 * 2;
    this.cartwidth = this.percentage(window.innerWidth, 75);
  }

  back() {
    if (
      this.scenario === 'planOverview' ||
      this.scenario === 'mealDetail' ||
      this.scenario === 'cheatDay'
    ) {
      this.shopService.back();
    } else {
      this.shopService.backToMain();
    }
  }

  getPrices() {
    this.showLoading = true;
    this.shopService.getPrices().then((res) => {
      if (res.isSuccess()) {
        if (this.scenario !== 'success' && this.scenario !== 'failed') {
          this.shopAnalytics.analyticShopVisited(this.scenario);
        }

        if (res.getData().getType() === 'autoDiscount') {
          // .discountplans.reverse();
          this.prices = res.getData().getPlanPrices();
          // .plans.reverse();
          // this.discountCode = th
          this.selecetDiscountPlans(this.prices);
        } else {
          this.prices = res.getData().getPlanPrices();
          this.selecetDiscountPlans(this.prices);

          // this.prices.sort((x, y) => x.promotion ? -1 : y.promotion ? 1 : 0);
          // this.prices.reverse();
          this.handleSlideTo();
        }

        this.lastId = this.prices.length - 1;
        this.oneLastId = this.prices.length - 2;
        this.currentCard = this.prices.length - 1;
        // console.log('ss', this.prices)
        // this.discountPrices = p.reverse();
        this.res1 = true;
        this.showLoading = !this.res1 || !this.res2;
        setTimeout(() => {
          const promotionEl = document.getElementById('promotion');
          if (promotionEl) promotionEl.scrollIntoView();
        }, 500);
        if (!this.showLoading && this.promotionCard !== -1) {
          // setTimeout(() => {
          //   this.selectCard(this.promotionCard);
          // }, 10);
        }
        this.cdr.detectChanges();
      } else {
        setTimeout(() => {
          this.showLoading = false;
          this.shopService.backToMain();
        }, 1000);
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
    });
  }
  handleSlideTo() {
    console.log(this.prices);

    this.prices?.forEach((price, i) => {
      let nearestCode = -1;
      if (price.promotion) {
        this.promotionCard = i;

        this.activeSlide = this.promotionCard;
      } else if (!nearestCode && this.discountCode) {
        nearestCode = i;
        this.promotionCard = i;
        this.activeSlide = this.promotionCard;
        (this.slider.nativeElement as any).slideTo(this.activeSlide);
      } else if (!this.promotionCard && !nearestCode && !this.discountCode) {
        this.activeSlide = 0;
      }
    });
  }
  counter(i: number) {
    return new Array(i);
  }
  getPromotionExpireDay(date: number) {
    return Math.floor((date - new Date().getTime()) / (24 * 60 * 60 * 1000));
  }
  getPlanSubscription() {
    this.showLoading = true;
    this.shopService.getPlanSubscription(true).then((res) => {
      if (res.isSuccess()) {
        this.remainingSubscription = res
          .getData()
          .getPlanSubscription().remainingDays;
        // console.log('remain', this.remainingSubscription)
        if (this.remainingSubscription === 0) {
          this.display = false;
        } else {
          this.display = true;
        }
        this.res2 = true;
        this.showLoading = !this.res1 || !this.res2;
        setTimeout(() => {
          const promotionEl = document.getElementById('promotion');
          if (promotionEl) promotionEl.scrollIntoView();
        }, 500);
        if (!this.showLoading && this.promotionCard !== -1) {
          // setTimeout(() => {
          //   this.selectCard(this.promotionCard);
          // }, 10);
        }
        this.cdr.detectChanges();
      } else {
        setTimeout(() => {
          this.showLoading = false;
          this.shopService.backToMain();
        }, 1000);
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
    });
  }

  nextCard() {
    if (this.currentCard > 0) {
      // this.analyticShopSwiped();
      if (this.currentCard < this.prices.length - 1) {
        document.getElementById(this.currentCard + 1 + 'page').style.right =
          'calc( 32px - 100% )';
      }
      document.getElementById(this.currentCard + 'page').style.right =
        'calc( 80px - 100% )';
      this.currentCard--;
      document.getElementById(this.currentCard + 'page').style.right = '32px';
      if (this.currentCard > 0) {
        document.getElementById(this.currentCard - 1 + 'page').style.right =
          'calc( 100% - 16px )';
      }
    }
  }

  previousCard() {
    if (this.currentCard < this.prices.length - 1) {
      // this.analyticShopSwiped();
      if (this.currentCard > 0) {
        document.getElementById(this.currentCard - 1 + 'page').style.right =
          'calc( 100% + 32px)';
      }
      document.getElementById(this.currentCard + 'page').style.right =
        'calc( 100% - 16px )';
      this.currentCard++;
      document.getElementById(this.currentCard + 'page').style.right = '32px';
      if (this.currentCard < this.prices.length - 1) {
        document.getElementById(this.currentCard + 1 + 'page').style.right =
          'calc( 80px - 100% )';
      }
    }
  }

  selectCard(index: number) {
    this.currentCard = index;
    for (let i = this.prices.length - 1; i > index + 1; i--) {
      document.getElementById(i + 'page').style.right = 'calc( 32px - 100% )';
    }
    if (index < this.prices.length - 1) {
      document.getElementById(index + 1 + 'page').style.right =
        'calc( 80px - 100% )';
    }
    document.getElementById(index + 'page').style.right = '32px';
    for (let i = index - 1; i >= 0; i--) {
      document.getElementById(i + 'page').style.right = 'calc( 100% - 16px )';
    }
  }

  purchase(cardId: number) {
    const dataLog = new ShopDataLogModel(
      this.prices[cardId].sku,
      this.prices[cardId].price,
      this.prices[cardId].title
    );
    localStorage.setItem('shop_data_log', JSON.stringify(dataLog));
    this.shopAnalytics.analyticShopPurchaseButtonClicked(
      this.prices[cardId].sku
    );

    this.shopService.purchase(this.prices[cardId]._id, this.discountCode);
  }

  showDiscountDialog() {
    const bottomSheetRef = this.matBottomSheet.open(
      ShopDiscountBottomsheetComponent,
      {
        panelClass: 'custom-shop-bottomsheet-container',
      }
    );
    // const dialogRef = this.dialog.open(ShopDiscountDialogComponent, {
    //   width: '90%',
    //   panelClass: 'custom-dialog-container',
    // });
  }

  generate(generateModel: GenerateModel) {
    this.showLoading = true;
    this.generateService
      .generate(
        generateModel.dietType.id,
        generateModel.weight,
        generateModel.startDay,
        generateModel.goal === 'weightLoss' ||
          generateModel.goal === 'weightGain'
          ? generateModel.calories[generateModel.difficulty].amount
          : parseInt(generateModel.calorie),
        generateModel.goal,
        this.activityLevelService.getActivityLevelEngNameById(
          generateModel.activityLevel
        ),
        generateModel.goal === 'weightLoss' ||
          generateModel.goal === 'weightGain'
          ? generateModel.calories[generateModel.difficulty].difficulty
          : 'none',
        generateModel.goal === 'pregnancy'
          ? generateModel.specialTypeStartDate
          : null,
        generateModel.goal === 'breastfeeding'
          ? generateModel.specialTypeStartDate
          : null,
        generateModel.isVegeterian ? ['5e5e3f0915d60303417e90d9'] : [],
        this.diseaseService.getDiseasesIds(generateModel.diseases),
        // [],
        this.hatedFoodService.getHatedFoodsIds(generateModel.hatedfoods),
        generateModel.dietType.type === 'daily'
          ? this.generateService.getFastingDaysArray(generateModel.fastingDays)
          : []
      )
      .then(async (res) => {
        if (res.isSuccess()) {
          let weightLog: Weightlog;
          const w = await this.weightLogService.getCurrentWeight();
          if (w.isSuccess()) {
            weightLog = w.getData().getWeightLog();
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
            this.showLoading = false;
          }

          let today = new Date();
          today = new Date(today.setHours(0, 0, 0, 1));
          if (
            this.dateHelper.isSameDay(today, new Date(weightLog.date)) &&
            weightLog._id !== '-'
          ) {
            this.weightLogService
              .updateWeight(generateModel.weight, weightLog._id)
              .then((result) => {
                if (result.isSuccess()) {
                  this.diaryAnalytics.analyticDiaryGetDietCompleted(
                    generateModel.goal,
                    generateModel.isVegeterian,
                    generateModel.goal === 'weightLoss' ||
                      generateModel.goal === 'weightGain'
                      ? generateModel.calories[generateModel.difficulty]
                          .difficulty
                      : 'none',
                    this.activityLevelService.getActivityLevelEngNameById(
                      generateModel.activityLevel
                    ),
                    generateModel.hatedfoods.length === 0 ? false : true,
                    generateModel.diseases.length === 0 ? false : true,
                    generateModel.startDay
                  );
                  this.calendarShared.selectedDate = new Date(
                    new Date().setHours(0, 0, 1, 0)
                  );
                  this.generateDataService.removeGenerate();
                  this.routeAnimationShared.showRouteAnimation();
                  this.router.navigate([mainUrl]);
                } else {
                  this.snackBarService.showSnackBar(
                    'خطا در برقراری ارتباط با سرور!'
                  );
                }
                this.showLoading = false;
              });
          } else {
            this.weightLogService
              .addWeight(today.getTime(), generateModel.weight)
              .then((result) => {
                if (result.isSuccess()) {
                  this.diaryAnalytics.analyticDiaryGetDietCompleted(
                    generateModel.goal,
                    generateModel.isVegeterian,
                    generateModel.goal === 'weightLoss' ||
                      generateModel.goal === 'weightGain'
                      ? generateModel.calories[generateModel.difficulty]
                          .difficulty
                      : 'none',
                    this.activityLevelService.getActivityLevelEngNameById(
                      generateModel.activityLevel
                    ),
                    generateModel.hatedfoods.length === 0 ? false : true,
                    generateModel.diseases.length === 0 ? false : true,
                    generateModel.startDay
                  );
                  this.calendarShared.selectedDate = new Date(
                    new Date().setHours(0, 0, 1, 0)
                  );
                  this.generateDataService.removeGenerate();
                  this.routeAnimationShared.showRouteAnimation();
                  this.router.navigate([mainUrl]);
                } else {
                  this.snackBarService.showSnackBar(
                    'خطا در برقراری ارتباط با سرور!'
                  );
                }
                this.showLoading = false;
              });
          }
        } else {
          this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          this.showLoading = false;
        }
      });
  }
  getTotalPrice() {
    return this.prices[this.activeSlide].totalPrice.toLocaleString();
  }
}
